import React from 'react';
import { Link } from 'react-router-dom';
import StarRating from './StarRating';

export default function ReviewCard({review}) {
  return (
    <article className="card" aria-labelledby={`title-${review.id}`}>
      <div className="thumbnail" aria-hidden>
        {review.imageUrl ? (
          <img src={review.imageUrl.startsWith('http') ? review.imageUrl : process.env.PUBLIC_URL + review.imageUrl}
            alt={review.altDesc}
            className='cardImg'
          />
        ) : (
          <div style={{ padding: 8 }}>{review.genre}</div>
        )}
      </div>
      <h3 id={`title-${review.id}`} className="review-title">
        <Link to={`/react-projects/gamerfrog/reviews/${review.id}`} style={{color:'inherit', textDecoration:'none'}}>{review.title}</Link>
      </h3>

      <div className="meta">
        <span>{review.platform}</span> • <span>{review.author}</span> • <time dateTime={review.date}>{review.date}</time>
      </div>

      <div style={{marginTop:8}}>{review.summary}</div>

      <div style={{marginTop:10}} className="controls">
        <StarRating value={review.rating} />
        <Link to={`/react-projects/gamerfrog/reviews/${review.id}`} className="btn ghost" style={{marginLeft:'auto'}}>Read More</Link>
      </div>
    </article>
  );
}
